import { createThunk, Model, model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { TutorialModel } from '@models/Tutorials/TutorialModel';
import { Api } from '@api';
import { CourseLessonUserStatsModel } from './CourseLessonUserStatsModel';

export class CourseLesson extends Model({
  id: types.identifierNumber,
  name: types.string,
  description: types.string,
  courseId: types.number,
  order: types.number,
  videos: types.array(types.reference(TutorialModel)),
  userStats: types.maybe(CourseLessonUserStatsModel),
}) {
  get tutorials() {
    return this.videos.slice();
  }

  get firstTutorial() {
    return this.tutorials[0];
  }

  get lastTutorial() {
    return this.tutorials[this.tutorials.length - 1];
  }

  start = createThunk(() => {
    return async function startLesson(this: CourseLesson) {
      await Api.Courses.startLesson({
        id: this.courseId,
        lessonId: this.id,
      });

      this.userStats?.setIsStarted(true);
    };
  });

  complete = createThunk(() => {
    return async function completeLesson(this: CourseLesson) {
      await Api.Courses.completeLesson({
        id: this.courseId,
        lessonId: this.id,
      });

      this.userStats?.setIsCompleted(true);
    };
  });
}

export const CourseLessonModel = model(CourseLesson);
